import React, { useState, useEffect, useCallback } from 'react';
import { useQueryClient, useQuery } from 'react-query';
import { injectIntl } from 'react-intl';

import { CirclePlusIcon } from 'icons';
import ShoppingAmount from '../containers/shopping/amount/item';

import messages from 'messages';

function Amount({ ...props }) {
    const queryClient = useQueryClient();
    const items = useQuery('items')?.data || [];
    const { formatMessage } = props.intl;

    const [update, setUpdate] = useState(false);

    const addGiftCard = useCallback(() => {
        let list = items;
        list.push(Math.floor(Math.random() * 7));

        queryClient.setQueryData('items', list);
        localStorage.setItem('items', JSON.stringify(list));

        setUpdate(true);
    });

    useEffect(() => {
        if (update) setUpdate(false);
    }, [update]);

    return (
        <div className="page-wrapper page-amount">
            {items.map((item, index) => (
                <ShoppingAmount key={index} item={item} />
            ))}

            <div className="add-more-gift-card" onClick={() => addGiftCard()}>
                <button className="btn-add-more" data-test="button-add-another-gift-card">
                    <CirclePlusIcon size={24} className="icon" />
                    <span>{formatMessage(messages.addAnotherGiftCard)}</span>
                </button>
            </div>
        </div>
    );
}

export default injectIntl(React.memo(Amount));
